import React from 'react';
import './ServicePages.css';

const NlpPage = ({ onContactClick }) => {
  const features = [
    { icon: "📝", title: "Sentiment Analysis", desc: "Detect customer emotions and opinions from reviews, social media, and support tickets in real time." },
    { icon: "📄", title: "Document Summarization", desc: "Automatically condense long documents, reports, and articles into concise, actionable summaries." },
    { icon: "🔍", title: "Named Entity Recognition", desc: "Extract people, organizations, locations, and custom entities from unstructured text data." },
    { icon: "🌍", title: "Multi-Lingual Processing", desc: "Process and analyze text in 100+ languages with high accuracy and cultural awareness." },
    { icon: "🗂️", title: "Text Classification", desc: "Automatically categorize documents, emails, and tickets into predefined or learned categories." },
    { icon: "🔗", title: "Relationship Extraction", desc: "Discover hidden connections and patterns between entities across large document collections." }
  ];

  return (
    <div className="service-page theme-nlp">
      <section className="svc-hero">
        <div className="svc-hero-content">
          <h1 className="svc-hero-title">Natural Language<br/>Processing</h1>
          <p className="svc-hero-subtitle">UNLOCK INSIGHTS FROM TEXT AND SPEECH AT SCALE.</p>
          <p className="svc-hero-desc">Transform unstructured text and voice data into structured, actionable insights that drive smarter business decisions.</p>
          <div className="svc-hero-stats">
            <div className="svc-stat-item"><h3>98%</h3><p>Classification Accuracy</p></div>
            <div className="svc-stat-item"><h3>100+</h3><p>Languages Supported</p></div>
            <div className="svc-stat-item"><h3>10x</h3><p>Faster Document Review</p></div>
          </div>
          <div className="svc-hero-cta">
            <button className="svc-btn-primary" onClick={onContactClick}>Book a Call</button>
            <button className="svc-btn-secondary"><span>▶</span> See Demo</button>
          </div>
        </div>
        <div className="svc-hero-visual">
          <div className="svc-glowing-ring">🗣️</div>
        </div>
      </section>

      <section className="svc-features-section">
        <h2 className="svc-section-title">NLP Capabilities</h2>
        <div className="svc-features-grid">
          {features.map((f, i) => (
            <div key={i} className="svc-feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 className="feature-title">{f.title}</h3>
              <p className="feature-desc">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="svc-cta-section">
        <div className="svc-cta-content">
          <h2>Ready to understand your data?</h2>
          <p>Book a call and we'll show you how NLP can transform your text processing workflows.</p>
          <button className="svc-btn-cta" onClick={onContactClick}>Book a Call</button>
        </div>
      </section>
    </div>
  );
};

export default NlpPage;
